const STORAGE_KEY = "reDirect_url";

export function isSafePostLoginPath(path) {
  return typeof path === "string" && path.startsWith("/") && !path.startsWith("//");
}

/** Remember where to send the user after they sign in (pathname + search only). */
export function savePostLoginRedirect(pathname, search = "") {
  const path = `${pathname}${search}`;
  if (!isSafePostLoginPath(path)) return;
  sessionStorage.setItem(STORAGE_KEY, path);
}

export function savePostLoginRedirectFromWindow() {
  savePostLoginRedirect(window.location.pathname, window.location.search);
}

/** Returns stored path and clears it, or null if missing/invalid. */
export function consumePostLoginRedirect() {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  sessionStorage.removeItem(STORAGE_KEY);
  if (!isSafePostLoginPath(raw)) return null;
  return raw;
}

export function peekPostLoginRedirect() {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw || !isSafePostLoginPath(raw)) return null;
  return raw;
}
